var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveySave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90301 4.86947V6.2224H2.55007C2.12947 6.2224 1.78537 6.52547 1.78537 6.89887V15.8175C2.02547 15.7417 2.28089 15.693 2.55007 15.693H17.8442C18.1134 15.693 18.3688 15.7417 18.6089 15.8175V6.89888C18.6089 6.52548 18.2648 6.22242 17.8442 6.22242H12.4912V4.86947H17.8442C19.109 4.86947 20.1383 5.77999 20.1383 6.89887V21.7812C20.1383 22.9001 19.109 23.8106 17.8442 23.8106H2.55007C1.28524 23.8106 0.255951 22.9001 0.255951 21.7812V6.89887C0.255951 5.77999 1.28525 4.86947 2.55007 4.86947H7.90301ZM17.8442 17.0459H2.55007C2.12947 17.0459 1.78537 17.349 1.78537 17.7224V21.7812C1.78537 22.1546 2.12947 22.4577 2.55007 22.4577H17.8442C18.2648 22.4577 18.6089 22.1546 18.6089 21.7812V17.7224C18.6089 17.349 18.2648 17.0459 17.8442 17.0459V17.0459ZM10.9623 0.810364V11.3538L14.2964 8.40307L15.3777 9.35961L10.1976 13.9434L5.01594 9.35961L6.09724 8.40307L9.43287 11.3538V0.810376H10.9623L10.9623 0.810364ZM4.84419 18.3989C3.99995 18.3989 3.31477 19.0063 3.31477 19.7518C3.31477 20.4973 3.99995 21.1048 4.84419 21.1048C5.68842 21.1048 6.37359 20.4973 6.37359 19.7518C6.37359 19.0063 5.68842 18.3989 4.84419 18.3989Z",
    fill: "#F9FEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveySave);
export default __webpack_public_path__ + "static/media/survey_save.8f04242220eff8a1f93425b282d4989a.svg";
export { ForwardRef as ReactComponent };